import React, { useState, useEffect, useContext } from "react";
import ReactGa from "react-ga";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { Button, Divider } from "@material-ui/core";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../../services/configs";
import useResizer from "../../../services/useResizer";
import Icon from "../../../fontIcons/icon";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import qs from "query-string";
import INRBalanceCard from "../INRBalanceCard";
import TextField from "@material-ui/core/TextField";
import { customAlphabet } from "nanoid/async";
import upi from "../../../assets/icons/upi.png";
import { AnimatePresence, motion } from "framer-motion";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import toast, { Toaster } from "react-hot-toast";
import numberCurrencyIn from "../../../services/indian-formatting";
import axios from "axios";
import useSWR, { useSWRConfig } from "swr";
import fetcher from "../../../api/swr_fetcher";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as styles from "./index.module.scss";
import { Tooltip } from "@material-ui/core";
import { useQuery } from "react-query";

const nanoid = customAlphabet("1234567890abcdef", 16);

export default function UPIDeposit(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [VPA, setVPA] = useState(null);
  const [amount, setAmount] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [added, setAdded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const token = useSelector((state) => state.trading.TOKEN);
  const { bannedTimeout, handleClickAlert } = useContext(CoinContext);

  const history = useHistory();
  const location = useLocation();

  const dispatch = useDispatch();

  const bankAccountQuery = useQuery(
    ["bankAccount"],
    () => fetcher("/v1/um/bankAccount").then((res) => res),
    {
      onSuccess: (data) => {
        if (data.upiStatus === "rejected" || data.upiStatus === "failed") {
          setError(true);
        } else {
          setError(false);
        }
      },
      onError: (data) => {},
    }
  );

  // const { data, error: VPAError } = useQuery(`/v1/um/bankAccount`, fetcher, {
  //   revalidateOnFocus: false,
  //   shouldRetryOnError: false,
  // });

  // useEffect(() => {
  //   toast.success(
  //     "The INR Deposit failed, kindly contact customer support! Any amount deducted would be credited back into your account.",
  //     { duration: 8000 }
  //   );
  // }, []);

  // useEffect(() => {
  //   if (VPAError?.status === 401) {
  //     bannedTimeout("timeout");
  //   } else if (VPAError?.status === 403) {
  //     bannedTimeout("banned");
  //   }
  // }, [VPAError]);

  useEffect(() => {
    if (
      bankAccountQuery.data?.upiId &&
      bankAccountQuery.data?.upiStatus == "verified"
    ) {
      setVPA(bankAccountQuery.data?.upiId);
      setConfirmed(true);
    }
  }, [bankAccountQuery.data]);

  useEffect(() => {
    const method = location.state?.method;
    if (method) {
      switch (method) {
        case "completed":
          toast.success(
            "INR Deposit successful! It might take a few minutes to reflect in wallet.",
            { duration: 8000 }
          );
          break;
        case "cancel":
          toast.error("INR Deposit request cancelled!", { duration: 5000 });
          break;
        case "i-have-paid":
          toast(
            "If you have made a successful payment, it will be credited to your wallet in a few minutes.",
            {
              icon: "ℹ️",
              duration: 8000,
            }
          );
          break;
        case "invalid":
          toast.error(
            "The INR Deposit failed, kindly contact customer support! Any amount deducted would be credited back into your account.",
            { duration: 10000 }
          );
          break;
      }
      history.replace({
        pathname: "/inr/deposit",
        search: "?type=upi",
        state: null,
      });
    }
  }, [location.state]);

  function onAddVPA(e) {
    e.preventDefault();

    const match = /[a-zA-Z0-9_-]{3,}@[a-zA-Z]{3,}/;
    let id = e.target.upi.value;
    if (!match.test(id)) {
      setError(true);
    } else {
      setError(false);
      // setConfirmed(true);
      setVPA(id);
      setModalOpen(true);
    }
  }

  async function processTransaction(e, upiId) {
    // /api/v1/transfers/UPI
    e.preventDefault();
    let amount = e.target.amount.value;
    const options = {
      headers: { Authorization: "Bearer " + token },
    };
    try {
      let response = await axios.post(
        `${REACT_APP_PROD_URL}/v1/transfers/UPI`,
        {
          amount: Number(amount),
        },
        options
      );
      response = response.data;
      console.log(response);
      let transaction_id = response.orderId;
      let transaction = {
        orderId: transaction_id,
        upiId: upiId,
        amount: Number(amount),
        createdAt: Date.now(),
      };
      dispatch({ type: "SET_UPI_TRANSACTION_DATA", payload: transaction });
      history.push(`/upi/request/${transaction_id}`);
    } catch (e) {
      let readableError = e.response?.data?.detail?.match(/"([^']+)"/)[1];
      alert(
        (Boolean(readableError) ? readableError : "") +
          " Please contact support!"
      );
    }
  }

  async function confirmVPA() {
    setLoading(true);
    const options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    try {
      let response = await axios.post(
        `${REACT_APP_PROD_URL}/v1/transfers/verifyUpi`,
        {
          upiId: VPA,
        },
        options
      );
      response = response.data;
      if (response.status == "success") {
        setAdded(true);
        setModalOpen(false);
        setError(false);

        setTimeout(() => {
          setAdded(false);
          setConfirmed(true);
        }, 2000);
      } else if (response.status == "failed") {
        setError(true);
      }
    } catch (e) {
      setError(true);
    } finally {
      setModalOpen(false);

      bankAccountQuery.refetch();
    }
    setLoading(false);
  }

  return (
    <div className="upi">
      <div className={classes.gridContainer}>
        <INRBalanceCard></INRBalanceCard>
        <Divider />
        <div className="dark:bg-[#141828]   p-5 py-8 pb-10 rounded-md">
          <h3 className="mb-5 ">
            {confirmed
              ? "UPI request will be sent to"
              : "Add your UPI/VPA for UPI payments"}
          </h3>
          <AnimatePresence>
            {added && (
              <div className="overflow-hidden">
                <motion.div
                  animate={{ y: 0, opacity: 1 }}
                  initial={{ y: 1000, opacity: 0 }}
                  transition={{
                    type: "tween",
                    stiffness: 100,
                    duration: 0.4,
                  }}
                  exit={{ y: 1000, opacity: 0 }}
                >
                  <Checkmark></Checkmark>
                </motion.div>
              </div>
            )}{" "}
          </AnimatePresence>
          {bankAccountQuery.isSuccess ? (
            !added ? (
              confirmed ? (
                <>
                  <div className="">
                    <motion.div
                      className="flex mb-5"
                      animate={{ y: 0, opacity: 1 }}
                      initial={{ y: 100, opacity: 0 }}
                      transition={{
                        type: "tween",
                        stiffness: 100,
                        duration: 0.4,
                        delay: 0.5,
                      }}
                    >
                      <img
                        src={upi}
                        style={{ height: "40px", width: "40px" }}
                        className="mr-3"
                      ></img>
                      <div>
                        <p className="text-gray-500 text-xs">UPI/VPA ID</p>
                        <h4 className="break-all">{VPA}</h4>
                      </div>
                    </motion.div>
                  </div>
                  <form onSubmit={(e) => processTransaction(e, VPA)}>
                    <motion.div
                      animate={{ y: 0, opacity: 1 }}
                      initial={{ y: 100, opacity: 0 }}
                      transition={{
                        type: "tween",
                        stiffness: 100,
                        duration: 0.4,
                        delay: 0.5,
                      }}
                      className="flex flex-col "
                    >
                      <div
                        className={`input-group ${
                          error && "error"
                        } mr-4  mb-3  w-full`}
                      >
                        <label>Enter Amount</label>

                        <input
                          type="number"
                          required
                          min="500"
                          step=".01"
                          name="amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                          className="dark:bg-[#090D1C] bg-[#eee] dark:text-white"
                        />

                        <div className="error-message">Invalid amount.</div>
                      </div>
                      {/* <div className="max-w-[50%] text-gray-400">
                      {Boolean(amount) &&
                        `Amount in words: ${numberCurrencyIn(amount)}`}
                    </div> */}
                      <Button
                        type="submit"
                        variant="contained"
                        disableElevation
                        color="primary"
                        className="mt-5"
                        style={{
                          maxWidth: isMobile ? "300px" : "20%",
                          height: "35px",
                          color: "white",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Continue
                      </Button>
                    </motion.div>
                  </form>
                </>
              ) : (
                <form onSubmit={onAddVPA}>
                  <div className="flex flex-wrap ">
                    <div
                      className={`input-group ${
                        error && "error"
                      } mr-4   w-full`}
                    >
                      <label className="flex items-center gap-2 mb-1">
                        UPI/VPA ID{" "}
                        {bankAccountQuery.data.upiStatus === "rejected" ? (
                          <div className="text-pb-secondary-100 bg-pb-secondary-100 bg-opacity-20 rounded-md px-2">
                            Rejected
                          </div>
                        ) : bankAccountQuery.data.upiStatus === "pending" ? (
                          <div className="text-[#F3BA2F]  bg-[#F3BA2F] bg-opacity-20 rounded-md px-2">
                            Under Verification
                          </div>
                        ) : (
                          ""
                        )}
                      </label>
                      <Tooltip
                        title={
                          bankAccountQuery.data.upiStatus === "pending"
                            ? "Your UPI ID is under verification"
                            : ""
                        }
                        arrow
                        enterDelay={0}
                        placement="bottom"
                      >
                        <input
                          type="text"
                          required
                          name="upi"
                          disabled={
                            bankAccountQuery.data.upiStatus === "pending"
                              ? true
                              : false
                          }
                          defaultValue={
                            bankAccountQuery.data.upiId
                              ? bankAccountQuery.data.upiId
                              : ""
                          }
                          placeholder="Ex: name@bankname"
                          className={`${styles.input} dark:bg-[#090D1C] bg-[#eee] dark:text-white`}
                        />
                      </Tooltip>
                      <div className="error-message mt-2">
                        Incorrect UPI ID. Make sure the UPI ID is valid and of
                        the format: name@bankname
                      </div>
                    </div>
                    {bankAccountQuery.data.upiStatus !== "pending" && (
                      <Button
                        type="submit"
                        variant="contained"
                        disableElevation
                        color="primary"
                        className="mt-5"
                        style={{
                          // width: isMobile ? "100%" : "25%",
                          height: "35px",
                          color: "white",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Verify
                      </Button>
                    )}
                  </div>
                </form>
              )
            ) : (
              ""
            )
          ) : (
            <p>Loading...</p>
          )}
        </div>
        <Divider></Divider>
        <div className={classes.subContainer}>
          <div
            className={classes.flexContainer}
            style={{
              borderBottomStyle: "solid",
              paddingBottom: "5px",
              borderColor: "red",
              borderWidth: "2px",
            }}
          >
            <BsExclamationCircle style={{ fontSize: "20px", color: "red" }} />
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Information
            </p>
          </div>
          <ol
            style={{
              marginTop: "10px",
              marginLeft: "25px",
            }}
          >
            <li>The INR deposit amount should be greater than ₹500.</li>

            <li className="text-pb-primary-100">
              Make sure that your UPI ID is linked to your registered bank
              account with PocketBits before depositing.
            </li>
          </ol>
        </div>
      </div>
      <Dialog
        open={modalOpen}
        className="text-center"
        // onClose={handleLogoutDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <strong>Confirmation</strong>
        </DialogTitle>
        <DialogContent className="mb-5">
          Are you sure you want to add the UPI ID <br></br>{" "}
          <strong className="text-pb-primary-100 break-all">{VPA}</strong>
        </DialogContent>
        <DialogActions
          style={{ paddingBottom: "20px" }}
          className="flex justify-center"
        >
          {loading ? (
            <CircularProgress></CircularProgress>
          ) : (
            <>
              <Button
                onClick={() => {
                  setModalOpen(false);
                }}
                color="primary"
                variant="outlined"
                style={{ fontWeight: "bold" }}
              >
                Modify
              </Button>

              <Button
                onClick={confirmVPA}
                color="primary"
                variant="contained"
                autoFocus
                style={{ fontWeight: "bold", color: "white" }}
              >
                Confirm
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

function Checkmark(props) {
  return (
    <svg
      class="checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
      <path
        class="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
}
const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },

  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },

  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
}));
